export type GenericPageBackgroundRepeat =
  | 'no-repeat'
  | 'repeat'
  | 'repeat-x'
  | 'repeat-y'
  | 'space'
  | 'round';

const GENERIC_PAGE_BACKGROUND_REPEAT_VALUES: readonly GenericPageBackgroundRepeat[] = [
  'no-repeat',
  'repeat',
  'repeat-x',
  'repeat-y',
  'space',
  'round',
];

export function normalizeGenericPageBackgroundRepeat(
  value: unknown,
): GenericPageBackgroundRepeat {
  if (
    typeof value === 'string' &&
    (GENERIC_PAGE_BACKGROUND_REPEAT_VALUES as readonly string[]).includes(value)
  ) {
    return value as GenericPageBackgroundRepeat;
  }
  return 'no-repeat';
}
